import { computed } from 'vue'

import i18n from '@/libs/i18n'

const t = i18n.global.t

export enum UserRole {
    Admin = 'admin',
    User = 'user',
}

export enum FilterTypes {
    Text = 1,
    Number = 2,
    Date = 3,
    Select = 4,
    MultiSelect = 5,
    Boolean = 6,
}

// PredefinedText is the localized standard CRUD toast text (reactive to locale changes).
export const PredefinedText = computed(() => ({
    AddSuccess: t('success.add'),
    EditSuccess: t('success.edit'),
    DeleteSuccess: t('success.delete'),
    ErrorOnAdd: t('errors.on_add'),
    ErrorOnEdit: t('errors.on_edit'),
    ErrorOnDelete: t('errors.on_delete'),
}))

// roleOptions are the selectable user roles for the user dialog.
export const roleOptions = computed(() => [
    { label: t('role.admin'), value: UserRole.Admin },
    { label: t('role.user'), value: UserRole.User },
])
